var map = {
	"./camp.png": 1748,
	"./circle.svg": 1526,
	"./creative.png": 1749,
	"./frontend.png": 1750,
	"./gamedesign.png": 1751,
	"./graphicdesign.png": 1752,
	"./junior.png": 1753,
	"./math-3-4.png": 1754,
	"./math-5-6.png": 1755,
	"./pc.png": 1756,
	"./pytpro-nosnake.png": 1757,
	"./pytpro.png": 1758,
	"./pytstart-nosnake.png": 1759,
	"./pytstart.png": 1760,
	"./quadrangle.svg": 1524,
	"./unity.png": 1761,
	"./videocontent.png": 1762,
	"./websites.png": 1763
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1525;